module.exports = __webpack_public_path__ + "img/PorkNetherlands.1543febe.png";